import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CustomerForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API}/customers/forgot-password`, { 
                email,
                store_id: "0" 
            });
            setSent(true);
            toast.success("Password reset email sent!");
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to send reset email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#FDFDFD] flex flex-col font-sans animate-fade-in">
            <Header />

            <div className="flex-1 flex items-center justify-center p-4 mt-20">
                <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100">
                    <div className="text-center mb-8">
                        <h1 className="text-2xl font-bold text-slate-900">Reset Password</h1>
                        <p className="text-slate-500 mt-2">
                            {sent ? "Check your email for reset instructions" : "Enter your email to receive a reset link"}
                        </p>
                    </div>

                    {sent ? (
                        <div className="text-center space-y-6">
                            <Button
                                onClick={() => setSent(false)}
                                variant="outline"
                                className="w-full h-11 rounded-xl text-amber-700 border-amber-700 hover:bg-amber-50"
                            >
                                Try another email
                            </Button>
                            <Link to="/customer/login">
                                <Button className="w-full h-11 rounded-xl font-bold bg-amber-700 hover:bg-amber-800 text-white mt-4">
                                    Back to Login
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="space-y-2">
                                <Label>Email Address</Label>
                                <Input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="h-11 rounded-xl"
                                />
                            </div>

                            <Button
                                type="submit"
                                disabled={loading}
                                className="w-full h-11 rounded-xl font-bold bg-amber-700 hover:bg-amber-800 text-white"
                            >
                                {loading ? 'Sending...' : 'Send Reset Link'}
                            </Button>
                        </form>
                    )}

                    <div className="mt-6 text-center">
                        <Link to="/customer/login" className="text-sm font-medium text-amber-700 hover:underline">
                            Back to Login
                        </Link>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
